import React from 'react';
import { useSelector } from 'react-redux';
import CompleteTodo from './completeTodo/CompleteTodo';

const CompleteTodoList = () => {
    const todos = useSelector(state => state.todos);

    return (
        <div>
            <div
                className="bg-gray-100 px-2 py-2 rounded-md"
            >
                <h1 className='text-center font-bold'>Completed Task</h1>
            </div>

            <div
                className="text-gray-700 text-sm max-h-[300px] overflow-y-auto"
            >
                {/* <!-- todo --> */}
                {
                    todos.filter((todo) => todo.completed).map(todo => (
                        <CompleteTodo key={todo.id} todo={todo} />
                    ))
                }

            </div>
        </div>
    );
};

export default CompleteTodoList;